import type { IsoDateStr } from '@moment/domain-types'

import { Temporal } from 'temporal-polyfill'

/**
 * Parse an `IsoDateStr` into a `Temporal.PlainDate`.
 *
 * `IsoDateStr` is a brand stamped onto values typed by Horizon codegen from
 * the OpenAPI `format: date` contract; it is not re-validated at runtime,
 * so a malformed value from the backend will reach this function. In that
 * case `Temporal.PlainDate.from` throws `RangeError`.
 */
export function parseIsoDate(value: IsoDateStr): Temporal.PlainDate {
  return Temporal.PlainDate.from(value)
}
